// extracted by mini-css-extract-plugin
export default {"container":"ImgIcon__container-d1roB"};